/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ReassignMachineFileReviewRequest model module.
 * @module model/ReassignMachineFileReviewRequest
 * @version 0.0.1
 */
class ReassignMachineFileReviewRequest {
    /**
     * Constructs a new <code>ReassignMachineFileReviewRequest</code>.
     * @alias module:model/ReassignMachineFileReviewRequest
     * @param targetSerial {String} 
     */
    constructor(targetSerial) { 
        
        ReassignMachineFileReviewRequest.initialize(this, targetSerial);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, targetSerial) { 
        obj['targetSerial'] = targetSerial;
    }

    /**
     * Constructs a <code>ReassignMachineFileReviewRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ReassignMachineFileReviewRequest} obj Optional instance to populate.
     * @return {module:model/ReassignMachineFileReviewRequest} The populated <code>ReassignMachineFileReviewRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReassignMachineFileReviewRequest();

            if (data.hasOwnProperty('targetSerial')) {
                obj['targetSerial'] = ApiClient.convertToType(data['targetSerial'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ReassignMachineFileReviewRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReassignMachineFileReviewRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ReassignMachineFileReviewRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['targetSerial'] && !(typeof data['targetSerial'] === 'string' || data['targetSerial'] instanceof String)) {
            throw new Error("Expected the field `targetSerial` to be a primitive type in the JSON string but got " + data['targetSerial']);
        }

        return true;
    }


}

ReassignMachineFileReviewRequest.RequiredProperties = ["targetSerial"];

/**
 * @member {String} targetSerial
 */
ReassignMachineFileReviewRequest.prototype['targetSerial'] = undefined;






export default ReassignMachineFileReviewRequest;

